import { Component, OnInit, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateEditSupplierDialogComponent } from '../../../admin/dialog/create-edit-supplier-dialog/create-edit-supplier-dialog.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { CreateEditNewsUpdatesDialogComponent } from '../../../admin/dialog/create-edit-news-updates-dialog/create-edit-news-updates-dialog.component';
import { CreateEditSectionDialogComponent } from 'src/app/admin/dialog/create-edit-section-dialog/create-edit-section-dialog.component';
import { CreateEditSolarFormDialogComponent } from 'src/app/admin/dialog/create-edit-solar-form-dialog/create-edit-solar-form-dialog.component';
import { supplierById } from '../../models/admin.model';

@Component({
  selector: 'app-custom-common-icon',
  templateUrl: './custom-common-icon.component.html',
  styleUrls: ['./custom-common-icon.component.scss']
})
export class CustomCommonIconComponent implements ICellRendererAngularComp {

  params: ICellRendererParams;
  private unsubscribe: Subject<void> = new Subject<void>();
  isModalClose: boolean;
  shareDocumentTagCell: boolean = false;
  shareDocumentTagVal: any[];
  checkBoxVisible: boolean;

  constructor(private router:Router,  private route: ActivatedRoute, private dialog: MatDialog, private userRepository: UserRepositoryService,) {
   }
  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params=params;
    if(this.params.colDef.cellRenderer == 'tagCell'){
      this.shareDocumentTagCell = true;
      this.checkBoxVisible = false;
      this.shareDocumentTagVal= this.params.valueFormatted.split(',');
    }
    if(this.params.colDef.cellRenderer == 'checkBoxInAssignSuppliers') {
      this.checkBoxVisible = true;
      this.shareDocumentTagCell = false;
    }
  }

  onCheckBoxClick(event) {
    console.log(event)
  }
   
  onEditSupplierClick(event){
  if(event.colDef.cellRenderer == 'supplierFormActionCell'){

    this.userRepository.getSupplierById(event.data.id)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe((usersList : supplierById) => {
     if(usersList) {
      const dialogRef = this.dialog.open(CreateEditSupplierDialogComponent, {
        data: {
          isEditUser: true,
          supplyUserData: usersList
        }
      });
      dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe))
        .subscribe(result => {
          if (result) {
            this.isModalClose = true;
            this.userRepository.editSup.next(true);
            // this.initUserGrid();
          }
        });
     }
    });
 
  }
  if(event.colDef.cellRenderer == 'newsUpdateFormActionCell'){
    const dialogRef = this.dialog.open(CreateEditNewsUpdatesDialogComponent, {
      width: '850px',
      data: {
        isEdit: true,
        data: event.data
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe))
      .subscribe(result => {
        if (result) {
          this.userRepository.onNewsModalClose.next(true);
        }
      });
  }

  if(event.colDef.cellRenderer == 'sectionFormActionCell'){
    const dialogRef = this.dialog.open(CreateEditSectionDialogComponent, {
      width: '850px',
      data: {
        isEdit: true,
        data: event.data
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe))
      .subscribe(result => {
        if (result) {
          this.userRepository.onHomeSectionModalClose.next(true);
        }
      });
  }

  if(event.colDef.cellRenderer == 'solarFormActionCell'){
    const dialogRef = this.dialog.open(CreateEditSolarFormDialogComponent, {
      width: '850px',
      data: {
        isEdit: true,
        data: event.data
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe))
      .subscribe(result => {
        if (result) {
          this.userRepository.onSolarFormModalClose.next(true);
        }
      });
  }
  }
  
  
  }
